import api from './api';

export const getCourseGraph = async (courseId) => {
  try {
    const response = await api.get(`/data/courses/${courseId}/details`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch course graph');
  }
};

// Relationship management functions
export const createConceptRelationship = async (startNodeId, endNodeId, relationshipType, properties = {}) => {
  try {
    const response = await api.post('/data/concepts/relationships', {
      start_node_id: startNodeId,
      end_node_id: endNodeId,
      relationship_type: relationshipType,
      properties
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to create relationship');
  }
};

export const updateConceptRelationship = async (relationshipId, properties) => {
  try {
    const response = await api.put(`/data/concepts/relationships/${relationshipId}`, { properties });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to update relationship');
  }
};

export const deleteConceptRelationship = async (relationshipId) => {
  try {
    const response = await api.delete(`/data/concepts/relationships/${relationshipId}`);
    return true; // Success, 204 No Content response
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to delete relationship');
  }
};

export const getResources = async (resource) => {
  try {
    const response = await api.get(`/data/${resource}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || `Failed to fetch ${resource}`);
  }
};

export const getResource = async (resource, id) => {
  try {
    const response = await api.get(`/data/${resource}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || `Failed to fetch ${resource} details`);
  }
};

export const createResource = async (resource, data) => {
  try {
    const response = await api.post(`/data/${resource}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || `Failed to create ${resource}`);
  }
};

export const updateResource = async (resource, id, data) => {
  try {
    const response = await api.put(`/data/${resource}/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || `Failed to update ${resource}`);
  }
};

export const deleteResource = async (resource, id) => {
  try {
    const response = await api.delete(`/data/${resource}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || `Failed to delete ${resource}`);
  }
};